import { createSlice } from '@reduxjs/toolkit';

import { printBimehNamehMosaferati } from 'Feature/Mosaferati/Common/Actions/action';

import { getMosaferatiBimehNamehByShomarehBimehNameh } from './action';
import { IMosaferatiBimehNamehListState } from './model';

const initialState: IMosaferatiBimehNamehListState = {
  loading: false,
  data: null,
};

export const mosaferatiBimehNamehDetailSlice = createSlice({
  name: 'Mosaferati/BimehNamehDetail',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMosaferatiBimehNamehByShomarehBimehNameh.pending, (state) => {
        state.loading = true;
        state.data = initialState.data;
      })
      .addCase(getMosaferatiBimehNamehByShomarehBimehNameh.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getMosaferatiBimehNamehByShomarehBimehNameh.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(printBimehNamehMosaferati.pending, (state) => {
        state.loading = true;
      })
      .addCase(printBimehNamehMosaferati.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(printBimehNamehMosaferati.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default mosaferatiBimehNamehDetailSlice.reducer;
